import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { createFormTemplate, updateFormTemplate } from 'actions/templates';
import CreateFormTemplate from 'containers/FormTemplate/Form/CreateFormTemplate';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Button } from '@haldor/ui';

var FormTemplate = /*#__PURE__*/function (_Component) {
  _inherits(FormTemplate, _Component);

  var _super = _createSuper(FormTemplate);

  /* Class setup */
  function FormTemplate(props) {
    var _this;

    _classCallCheck(this, FormTemplate);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters
        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      // cancel form
      event.preventDefault();

      if (_this.props.onAbort != null) {
        _this.props.onAbort();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
      return new Promise(function (resolve) {
        // Todo: Add support for all other form attributes here
        values.fields = _this.state.fields;
        values.status = 'PUBLISHED';

        if (_this.props.initialValues != null) {
          _this.props.updateFormTemplate(values).then(function () {
            resolve(1);

            if (_this.props.onAbort != null) {
              _this.props.onAbort(true);
            }
          });
        } else {
          _this.props.createFormTemplate(values).then(function () {
            resolve(1);

            if (_this.props.onAbort != null) {
              _this.props.onAbort(true);
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFieldsChange", function (fields) {
      _this.setState({
        fields: fields
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, warning)));
    });

    var _fields = []; // Todo: Change so we can send an entire form object as prop and set fields from that

    if (props.fields != null && props.fields.length > 0) {
      _fields = _toConsumableArray(props.fields);
    }

    if (props.initialValues != null && props.initialValues.fields != null && props.initialValues.fields.length > 0) {
      _fields = _toConsumableArray(props.initialValues.fields);
    }

    _this.state = {
      fields: _fields
    };
    return _this;
  }
  /* Helper methods */


  _createClass(FormTemplate, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          valid = _this$props.valid;
      var isEditing = false;
      var disableSave = false;

      if (this.state.fields.length == 0) {
        disableSave = true;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.onSubmit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('template-name')), /*#__PURE__*/React.createElement(Field, {
        component: this.renderInput,
        type: "text",
        name: "title",
        validate: this.required
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider",
        style: {
          marginBottom: 40
        }
      }), /*#__PURE__*/React.createElement(CreateFormTemplate, {
        fields: this.state.fields,
        onChange: this.onFieldsChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, isEditing ? /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid || disableSave
      }, this.props.translate('save')) : /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid || disableSave
      }, this.props.translate('publish')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, this.props.translate('Cancel'))))));
    }
  }]);

  return FormTemplate;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations) //initialValues: state.Templates.formTemplate,

  };
}

export default connect(mapStateToProps, {
  createFormTemplate: createFormTemplate,
  updateFormTemplate: updateFormTemplate
})(reduxForm({
  form: 'CreateFormTemplate',
  destroyOnUnmount: true
})(FormTemplate));